var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyRecordings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 19L17 14V24L25 19Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 19C8 12.3726 13.3726 7 20 7C26.6274 7 32 12.3726 32 19C32 25.6274 26.6274 31 20 31C13.3726 31 8 25.6274 8 19ZM20 9C14.4772 9 10 13.4772 10 19C10 24.5228 14.4772 29 20 29C25.5228 29 30 24.5228 30 19C30 13.4772 25.5228 9 20 9Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47 27C47 26.4477 47.4477 26 48 26H70C70.5523 26 71 26.4477 71 27C71 27.5523 70.5523 28 70 28H48C47.4477 28 47 27.5523 47 27Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48 18C47.4477 18 47 18.4477 47 19C47 19.5523 47.4477 20 48 20H70C70.5523 20 71 19.5523 71 19C71 18.4477 70.5523 18 70 18H48Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47 11C47 10.4477 47.4477 10 48 10H70C70.5523 10 71 10.4477 71 11C71 11.5523 70.5523 12 70 12H48C47.4477 12 47 11.5523 47 11Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4C0 1.79086 1.79086 0 4 0H76C78.2091 0 80 1.79086 80 4V34C80 36.2091 78.2091 38 76 38H4C1.79086 38 0 36.2091 0 34V4ZM4 2C2.89543 2 2 2.89543 2 4V34C2 35.1046 2.89543 36 4 36H76C77.1046 36 78 35.1046 78 34V4C78 2.89543 77.1046 2 76 2H4Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25 61L17 56V66L25 61Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 61C8 54.3726 13.3726 49 20 49C26.6274 49 32 54.3726 32 61C32 67.6274 26.6274 73 20 73C13.3726 73 8 67.6274 8 61ZM20 51C14.4772 51 10 55.4771 10 61C10 66.5229 14.4772 71 20 71C25.5228 71 30 66.5229 30 61C30 55.4771 25.5228 51 20 51Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47 69C47 68.4477 47.4477 68 48 68H70C70.5523 68 71 68.4477 71 69C71 69.5523 70.5523 70 70 70H48C47.4477 70 47 69.5523 47 69Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M48 60C47.4477 60 47 60.4477 47 61C47 61.5523 47.4477 62 48 62H70C70.5523 62 71 61.5523 71 61C71 60.4477 70.5523 60 70 60H48Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M47 53C47 52.4477 47.4477 52 48 52H70C70.5523 52 71 52.4477 71 53C71 53.5523 70.5523 54 70 54H48C47.4477 54 47 53.5523 47 53Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 46C0 43.7909 1.79086 42 4 42H76C78.2091 42 80 43.7909 80 46V76C80 78.2091 78.2091 80 76 80H4C1.79086 80 0 78.2091 0 76V46ZM4 44C2.89543 44 2 44.8954 2 46V76C2 77.1046 2.89543 78 4 78H76C77.1046 78 78 77.1046 78 76V46C78 44.8954 77.1046 44 76 44H4Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyRecordings);
export default __webpack_public_path__ + "static/media/empty-recordings.c35339b6a01325996c7fa6407dc15d74.svg";
export { ForwardRef as ReactComponent };